import "../../../styles/Print.scss";
import { useMemorandumLogo } from "hooks/MemorandumLogo";
import { FormatDate, FormatDateShort } from "utils/dateUtils";
import { FormatNumber, FormatNumberOrNull } from "utils/numberUtils";
import { useSelector } from "react-redux";
import { selectState } from "../main.slice";

const PrintPartners = () => {
  const memorandumLogo = useMemorandumLogo();
  const { partners } = useSelector(selectState);

  return (
    <>
      <div className="logo">
        {memorandumLogo && <img src={memorandumLogo} alt="" />}
      </div>
      <h1 className="header-consumables-output">SARADNICI</h1>
      <div className="partners-date">
        {FormatDate(new Date().toISOString())}
      </div>
      <table className="table-partners-ts table-header-partners">
        <tbody>
          <tr>
            <th>ime</th>
            <th>valuta</th>
            <th>potraživanja</th>
            <th>dugovanja</th>
            <th>xxx</th>
            <th>valuta</th>
          </tr>
        </tbody>
      </table>
      <table className="table-partners-ts table-body partners-t">
        <tbody>
          {partners.filter(partner =>
            ((partner.payablesTotalOutstandingAmount ?? 0) > 0) ||
            ((partner.receivablesTotalDebtAmount ?? 0) > 0))
            .map((partner, index) => {
              return (
                <tr key={index}>
                  <td>{partner.shortName}</td>
                  <td>
                    {partner.payablesNextDueDate &&
                      FormatDateShort(partner.payablesNextDueDate)}
                  </td>
                  <td>
                    {FormatNumberOrNull(partner.receivablesTotalDebtAmount)}
                  </td>
                  <td>
                    {FormatNumberOrNull(partner.payablesTotalOutstandingAmount)}
                  </td>
                  <td>
                    {FormatNumberOrNull(partner.payablesTotalOutstandingXxxAmount)}
                  </td>
                  <td>
                    {partner.receivablesNextDueDate &&
                      FormatDate(partner.receivablesNextDueDate)}
                  </td>
                </tr>
              );
            })}
        </tbody>
        <tfoot>
          <tr className="tfooter">
            <td colSpan={2}></td>
            <td>{FormatNumber(partners.reduce((total, p) => total + (p.receivablesTotalDebtAmount || 0), 0))}</td>
            <td>{FormatNumber(partners.reduce((total, p) => total + (p.payablesTotalOutstandingAmount || 0), 0))}</td>
            <td>{FormatNumber(partners.reduce((total, p) => total + (p.payablesTotalOutstandingXxxAmount || 0), 0))}</td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </>
  );
};

export default PrintPartners;
